
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vqvuhbqdhoidwecmzech.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZxdnVoYnFkaG9pZHdlY216ZWNoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE5ODE1NDUsImV4cCI6MjA1NzU1NzU0NX0.riPSesx_FAu-1Sb9_1XvluFugG2HbUGpzpmtQ844O6M";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  },
  global: {
    headers: {
      'X-Client-Info': 'clustr-app'
    }
  }
});
